// extracted by mini-css-extract-plugin
export default {"Lightwave":"Waves_Lightwave__3ONBN","Bluewave":"Waves_Bluewave__TfL3R"};